import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import { firestore } from './FirebaseConfig';
import { Stack, Grid, Card, Button, Divider } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import BlogTitle from './BlogTitle';
import Paragraph from './Paragraph';
import MoreProducts from './MoreProducts';
import CardLoader from './CardLoader';



const ProductDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [imageSrc, setImageSrc] = useState('');  
  const [category, setCategory] = useState('');
  const [productId, setProductId] = useState('');
  const [features, setFeatures] = useState([]);
  const [moreImages, setMoreImages] = useState([]);
  const [date, setDate] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const history = useNavigate();
  const [productFeatures, setProductFeatures] = useState([]);
  const slug = id;

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productRef = firestore.collection('egress-window-products').doc(id);
        const doc = await productRef.get();

        if (!doc.exists) {
          console.log('No matching document.');
          return;
        }

        const productData = doc.data();
        
        setTitle(productData.product_title);
        setContent(productData.product_description);
        
        setCategory(productData.product_category);
        setFeatures([productData.product_features]);
        setDate(Date.now(),);
        setProductId(productData.product_id);
        setImageSrc(productData.coverImg);        
        setMoreImages(productData.images || []);
        setMinPrice(productData.price[0]);
        setMaxPrice(productData.price[2]);
        setProductFeatures(productData.product_features || []);
        const firstPriceItem = productData.price?.[0];
        if (firstPriceItem && firstPriceItem.list) {
          setMinPrice(firstPriceItem.list);
        }

        const lastPriceItem = productData.price?.[1];
        if (lastPriceItem && lastPriceItem.max) {
          setMaxPrice(lastPriceItem.max);
        }
        

        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    };

    fetchProduct();
  }, [id]);

  const handleProductClick = (newProdId) => {       
    history.push(`/egress-window-products/${newProdId}`); // Navigate to the new article route
  };

  const images = moreImages.map(image => image.src);

  

  // Convert and format the date
  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  const richSnippetMarkup = JSON.stringify({
    
       "@context": "http://schema.org", 
  "@type": "Product", 
  "@id": `https://jacksonegresswindows.com/product-page/${id}`, 
  "name": title, 
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5.00", 
  "reviewCount": 5 } 
    
  });

  

  

  return (
    
    
    <Stack
      id='product-details'
      component='section'
      direction='column'
      minWidth='300px'
      width='90%'
      paddingTop='200px'
      paddingBottom='100px'
      justifyContent='center'
      alignItems='center'
      marginBottom={'20px'}
      marginTop={'200px'}
      sx={{
        py: '100px',
        mx: 6,
        maxWidth: '800px',
        margin: '0px auto',
        opacity: loading ? 0.5 : 1,
        transition: 'opacity 2s ease-in-out',
      }}
    >
      <Helmet>
        
        <script type='application/ld+json'>{richSnippetMarkup}</script>
      </Helmet>
     
      {loading ? (
        <CardLoader/>
       
      ) : (
        <>
          <BlogTitle text={title} fontFamily='League Spartan sans-serif' textAlign='left' sx={{color: '#000000'}} />

          {imageSrc && (
            <img
              src={imageSrc}
              alt={title}
              style={{
                width: '100%',
                maxWidth: '800px',
                height: 'auto',
                borderRadius: '10px',
                marginTop: '40px',
                marginBottom: '10px',
              }}
            />
          )}

          <Card
          style={{
            backgroundColor: '#ffffff',
            height: 'fit-content',
            justifyItems: 'baseline',
            alignContent:'center',
            width: '82vw',
            maxWidth: '800px',
            padding: '10px',
            paddingRight: '20px',
            marginBottom: '25px',
            marginTop: '25px',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px'}}>
        <Grid style={{display: 'flex',
            msFlexDirection: 'row',
            flexWrap:'wrap',
            borderRadius: '8px'}}>  
       <div className="image-list">
       {moreImages.map((image, index) => (
         <div key={index} className="image-item" style={{textAlign: 'center'}}>
           <img src={image.src} alt={image.caption} style={{ width: '100%' }} />
           <p>{image.caption}</p>
         </div>
       ))}
     </div>
    </Grid>
      
    <div className="product-features">
      
        {productFeatures.map((feature, index) => (
          <List key={index} className="feature-item">
            <ListItem alignItems="flex-end" id={`feature_${index}`} style={{border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: '10px', color:'#0c4d13', marginBottom:'10px', paddingTop: '10px', paddingBottom: '10px'}} >     
            
            
            <p htmlFor={`feature_${index}`}>{feature.text}</p> 
             
           
            </ListItem>
            </List>
            
        ))}
        
</div>
        
    
    </Card>
          

                 <Grid               
                 sx={{
                   width: '90%',
                   display: 'flex',
                   flexDirection: 'row',
                   flexWrap: 'wrap',
                   justifyItems: 'baseline',
                   alignItems: 'center',
                   verticalAlign: 'middle',
                   height: '100px',
                   marginBottom: '0px'
                 }}
                       >



      
             </Grid>

            

             <Grid
                 item
                 sx={{
                   width: '90%',
                   display: 'flex',
                   flexDirection: 'row',
                   flexWrap: 'wrap',
                   justifyItems: 'baseline',
                   alignItems: 'center',
                   verticalAlign: 'middle',
                 }}
             >
              
          
             
             </Grid>
        
          <Paragraph
            text={content}
            maxWidth='90vw'
            mx={0}
            textAlign='left'
            whiteSpace='pre-wrap'
            sx={{ color: '#121212', marginBottom: '40px', paddingBottom: '40px', whiteSpace: 'pre-wrap'}}
          />
          <Divider color="primary">
    
  </Divider>
          
            
            <Button
  component={NavHashLink}
  to={'/contact#quote-form'}
  variant="contained"
  type="submit"
  size="medium"
  padding='20px'
  sx={{
    fontSize: '2rem',
    fontFamily: 'Roboto',
    textTransform: 'capitalize',
    padding: '20px',
    py: 2,
    px: 4,
    mt: 3,
    mb: 2,
    width: '100%',
    margin: '0px auto',
    borderRadius: 1.5,
    backgroundColor: '#4dc548',
    zIndex: 4,
    "&:hover": {
      backgroundColor: '#0deb2a',
    }
  }}
>
  Get Quote
</Button>
            
         
          
          <div>
  
  
  
</div>

          <MoreProducts sx={{opacity: loading ? 0 : 1}} onProductClick={handleProductClick} />
         
        </>
      )}
    </Stack>
  );
};

export default ProductDetails;


/*
<div className="image-list" sx={{
                   width: '100%',
                   display: 'flex',
                   flexDirection: 'row',
                   flexWrap: 'nowrap',
                   justifyItems: 'space-evenly',
                   alignItems: 'center',
                   verticalAlign: 'middle',
                   height: '90px',
                   justifyContent: 'center'
                 }}>
        {moreImages.map((image, index) => (
          <div key={index} className="image-item" style={{textAlign:'center'}}>
            <img src={image.src} alt={image.caption} style={{width: '100px', objectFit: 'cover'}} />
            <p>{image.caption}</p>
          </div>
        ))}
      </div>
*/